/** `?product=` values that share the CRM portal line (show portal select on sign-up). */
export const CRM_PORTAL_PRODUCT_QUERIES = new Set(['crm', 'gym', 'education', 'clinics']);

export function isCrmPortalProductQuery(product: string | null): boolean {
    if (!product) return false;
    return CRM_PORTAL_PRODUCT_QUERIES.has(product.trim().toLowerCase());
}

/** Maps `?product=` query values to `project_type` sent on register (API base varies by type — see signupApiUrls). */
export const PRODUCT_QUERY_TO_PROJECT_TYPE: Record<string, string> = {
    crm: 'crm',
    fleet: 'fleet',
    'hr-management': 'hr_management',
    clinico: 'clinico',
    gym: 'gyms',
    gyms: 'gyms',
    education: 'educational_centers',
    'educational-centers': 'educational_centers',
    clinics: 'clinics',
};

/** i18n key under `signUp` for each `?product=` value (display name on sign-up). */
export const PRODUCT_QUERY_TO_SIGNUP_LABEL_KEY: Record<string, string> = {
    crm: 'productsCrm',
    fleet: 'fleet',
    'hr-management': 'hrManagement',
    clinico: 'productsClinico',
    gym: 'gyms',
    gyms: 'gyms',
    education: 'educational',
    'educational-centers': 'educational',
    clinics: 'clinics',
};

export function projectTypeFromProductQuery(product: string | null): string | undefined {
    if (!product) return undefined;
    return PRODUCT_QUERY_TO_PROJECT_TYPE[product.toLowerCase()];
}

export function signupLabelKeyForProductQuery(product: string | null): string | undefined {
    if (!product) return undefined;
    return PRODUCT_QUERY_TO_SIGNUP_LABEL_KEY[product.toLowerCase()];
}
